// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__3dMto","info":"UpdateTermsInfo_info__LF4RO"};